
import { Component, Emit, Vue, Prop } from "vue-property-decorator";
import MapApp from "@/plugin/gis-viewer/MapAppCloudRender";
import { IMapContainer, IAssetModel, IResult, RemoveAss, IOverlayParameter, IOverlayDelete, IResultCloudRender } from "@/types/map";

@Component({
    name: "MapContainerCloudRender",
})
export default class MapContainerCloudRender extends Vue implements IMapContainer {
    @Prop({ type: Object }) readonly mapConfig!: any;
    private mapApp!: MapApp;

    async mounted() {
        this.mapApp = new MapApp();
        await this.mapApp.init("divCMap", this.mapConfig, (res: any) => {
            this.mapLoaded(this.mapApp);
        });
    }
    public async setWebsocket(): Promise<any> {
        return this.mapApp;
    }
    public async setCameraInfo(params: any): Promise<IResultCloudRender> {
        return await this.mapApp.setCameraInfo(params);
    }
    public async performExtendAction(params: any): Promise<IResultCloudRender> {
        return await this.mapApp.performExtendAction(params);
    }
    public async setMapCenterAndLevel(params: any): Promise<void> {
        return await this.mapApp.setMapCenterAndLevel(params);
    }
    public async addAssetModel(params: IAssetModel): Promise<IResult> {
        return await this.mapApp.addAssetModel(params);
    }
    public async removeAssetModel(params: RemoveAss): Promise<IResult> {
        return await this.mapApp.removeAssetModel(params);
    }
    public async addOverlays(params: IOverlayParameter): Promise<IResult> {
        return await this.mapApp.addOverlays(params);
    }
    public async deleteOverlays(params: IOverlayDelete): Promise<IResult> {
        return await this.mapApp.deleteOverlays(params);
    }
    public async closeClientWebsocket(): Promise<void> {
        return await this.mapApp.closeClientWebsocket();
    }
    //自定义地图加载事件
    @Emit("map-loaded")
    private mapLoaded(res: any) {
        //do nothing
        console.log(this.mapApp, 1112);

        return this.mapApp;
    }
}
